import { db } from '../../../config/firebase-config';
import {
    getDocs,
    getDoc,
    collection,
    addDoc,
    doc,
    updateDoc,
    arrayUnion,
    setDoc,
    arrayRemove
} from 'firebase/firestore';

let TABLE_NAME = "PDFTemplates"; //default

const formCollectionRef = collection(db, TABLE_NAME);

//Get All Items
export const getAllForms = async () => {
    try {
        const data = await getDocs(formCollectionRef);
        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            Id: doc.id
        }))
        return filteredData;
    } catch (error) {
        throw error;
    }
}

//Get by DocID
export const getFormByID = async (docID , tbName=TABLE_NAME) => {
    const docRef = doc(db, tbName , docID);

    try {
        const docSnap = await getDoc(docRef);
        return docSnap.data();
    } catch (error) {
        throw error;
    }
}

//Add new Item
export const addNewForm = async (docData) => {
    
    try {
        // const data = await addDoc(formCollectionRef, docData , docID);
        
        const docRef = doc(formCollectionRef, docData.DocID);
        await setDoc(docRef, docData);

        return docData;
    } catch (error) {
        console.log(error)
        throw error;
    }
}

//Update Item
export const updateForm = async (docID, docData) => {
    try {
        const formDocRef = doc(db, TABLE_NAME, docID);

        // const data = await addDoc(formCollectionRef, docData);
        const data = await updateDoc(formDocRef, docData);

        return data;
    } catch (error) {
        alert(error)
        throw error;
    }
}

//Add new property / fields
export const addFieldsToFormTable = async (docData, docID, field , tbName=TABLE_NAME) => {

    const formDocRef = doc(db, tbName, docID);

    try {
        const data = await updateDoc(formDocRef, {
            [field]: arrayUnion(docData)
        });
        console.log(data)
    } catch (error) {
        console.log(error)
        alert(error)
        throw error;
    }
}
export const removeFieldToFormTable = async (fieldToRemove, docID, field , tbName=TABLE_NAME) => {

    const formDocRef = doc(db, tbName, docID);
    
    try {
        // Step 1: Retrieve the document
        const doc = await getDoc(formDocRef);
        if (!doc.exists()) {
            throw new Error('Document does not exist');
        }
    
        // Step 2: Manipulate the array to remove objects with a specific property value
        const currentArray = doc.data()[field]; // Assuming 'field' is the array field in your document
        const newArray = currentArray.filter(item => item.FieldName2 !== fieldToRemove); // Replace 'property' with your actual object property and 'valueToRemove' with the value to match
    
        // Step 3: Update the document with the new array
        await updateDoc(formDocRef, {
            [field]: newArray
        });
    
        console.log('Document updated successfully');
    } catch (error) {
        console.error('Error updating document:', error);
        alert(error.message); // Assuming you're using this in a web context where alert is available
        throw error;
    }
}